module.exports = __webpack_public_path__ + "assets/img/1321587607140_.pic_hd.3353b741.jpg";